import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { environment } from '@wo-environments';

@Injectable()
export class ConsentApprovalApiService {
  private static readonly ENDPOINT = `${ environment.backendHost }/user/consent`;
  private readonly http = inject(HttpClient);

  public sendConsent(): Observable<HttpResponse<string>> {
    return this.http.post(
      ConsentApprovalApiService.ENDPOINT,
      '',
      {
        observe: 'response',
        responseType: 'text',
      });
  }
}
